// A leading bullet or number marker: "•", "-", "*", "1.", "2)", "(3)", "a." ...
const LIST_MARKER =
  /^\s*(?:[•◦▪▫‣⁃●○■□–—*+-]|\(?\d{1,3}[.)]|\(?[a-zA-Z][.)])\s+/;

const cleanText = (text) => text.replace(/\s+/g, " ").trim();

/**
 * Turn pasted clipboard content into list item texts, in reading order.
 *
 * - HTML (Google Docs, websites): one item per <li>, nested lists flattened.
 * - Plain text: one item per line, with bullet/number markers stripped.
 *
 * Returns null unless there are at least two items, so pasting a single line
 * still behaves like a normal paste.
 *
 * @param {DataTransfer} clipboardData
 * @returns {string[] | null}
 */
export const parsePastedList = (clipboardData) => {
  if (!clipboardData) return null;
  let items = [];

  const html = clipboardData.getData("text/html");
  if (html && /<li[\s>]/i.test(html)) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    items = Array.from(doc.querySelectorAll("li")).map((li) => {
      // Only the item's own text - nested lists become their own items
      const clone = li.cloneNode(true);
      clone.querySelectorAll("ul, ol").forEach((list) => list.remove());
      return cleanText(clone.textContent || "");
    });
  } else {
    const text = clipboardData.getData("text/plain") || "";
    items = text
      .split(/\r?\n/)
      .map((line) => cleanText(line.replace(LIST_MARKER, "")));
  }

  items = items.filter(Boolean);
  return items.length >= 2 ? items : null;
};
